<i18n>
{
"en": {
  "NOTACESS": "Forbidden",
  "LOST": "You don't have permission to access.",
  "GOHOME": "Go Home"
},
"ar": {
  "NOTFOUND": "ممنوع",
  "LOST": "ليس لديك إذن للوصول.",
  "GOHOME": "اذهب للمنزل"
}
}
</i18n>
<template>
    <el-card  class="card-border" ref="card" id="report" :body-style="{ padding: 0 }" :style="{ height: cardHeight + 'px' }">
        <el-row :gutter="20" style="padding: 20px;">
            <el-col :span="24">
                <div class="page-403">
                    <i class="fa fa-hand-paper-o fa-5x"></i>
                    <h1>{{$t('NOTACESS')}}</h1>
                    <h3>{{$t('LOST')}}</h3>
                    <p><el-button @click="$router.push('/')">{{$t('GOHOME')}}</el-button></p>
                    
                </div>
            </el-col>
        </el-row>
    </el-card>
</template>
<script>
export default {
  data () {
    return {
      cardHeight: 0
    }
  },
  mounted () {
    this.switchLanguage()
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - this.$el.offsetHeight - 53
    })
  }
}
</script>
<style>
.page-403{
    text-align: center;
    padding: 120px 0px;
    background-color: #fff;
}
.page-403 h1{
    font-size: 200px;
}
.page-403 h3{
    font-size: 35px;
    margin-bottom: 20px;
}
.page-403 p{
    font-size: 20px;
}
.page-403 .el-button{
    text-transform: uppercase;
    font-weight: 600;
    padding: 15px 35px;
    background-color: #f4c135;
    border-color:#fff;
    color:#fff;
    border-radius: 30px;
}
.page-403 .el-button:hover{
    background: transparent;
        border-color: #f4c135;
    color:#f4c135;
}
.page-403 .svg-inline--fa{
    font-size: 30px;
    position: relative;
    top: -5px;
    margin-right: 10px;
    text-align: center;
}
.page-403 h2{
    text-transform: uppercase;
    font-size: 40px;
    padding: 10px 40px;
    color:#fff;
    background-color: #333;
    display: inline-block;
    border-radius: 3px;
}
</style>




// WEBPACK FOOTER //
// 403.vue?37a088cf